import axios from "axios";
// import Cookies from "js-cookie";
// import { CloudSnow } from "lucide-react";

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}

export const categoryUrls = {
  "Coffee / ቡና": `${process.env.REACT_APP_BASE_URL}/CoffeeandMainCommodity`,
  "Spice & Herbs / ቅመማ ቅመሞቾ": `${process.env.REACT_APP_BASE_URL}/spices`,
  "Building Materials / የግንባታ እቃዎች": `${process.env.REACT_APP_BASE_URL}/BuildingMaterials`,
  "Grains and Cereals / የእህል ሰብሎች": `${process.env.REACT_APP_BASE_URL}/GrainsandCerials`,
  "Pulses & Legumes / ጥራጥሬዎች ": `${process.env.REACT_APP_BASE_URL}/pulse`,
  "Oil Seeds / የቅባት እህሎች": `${process.env.REACT_APP_BASE_URL}/oilSeed`,
  "Root Crops / የስራስር ሰብሎች": `${process.env.REACT_APP_BASE_URL}/rootCrop`,
  "Vegetables  / አትክልቶች": `${process.env.REACT_APP_BASE_URL}/vegetable`,
  "Fruit Crops / ፍራፍሬች": `${process.env.REACT_APP_BASE_URL}/fruit`,
};

export const categoryUrlsforRepost = {
  "CoffeeAndMainCommodities": `${process.env.REACT_APP_BASE_URL}/CoffeeandMainCommodity`,
  "SpicesHerbs": `${process.env.REACT_APP_BASE_URL}/spices`,
  "BuildingMaterials": `${process.env.REACT_APP_BASE_URL}/BuildingMaterials`,
  "GrainsAndCereals": `${process.env.REACT_APP_BASE_URL}/GrainsandCerials`,
  "PulsesLegumes": `${process.env.REACT_APP_BASE_URL}/pulse`,
  "OilSeeds": `${process.env.REACT_APP_BASE_URL}/oilSeed`,
  "RootCrops": `${process.env.REACT_APP_BASE_URL}/rootCrop`,
  "Vegetables": `${process.env.REACT_APP_BASE_URL}/vegetable`,
  "FruitCrops": `${process.env.REACT_APP_BASE_URL}/fruit`,
};

export const addProducts = async (
  productData, // productData may contain name, description, details, measurement
  categoryName,
  pictureLink
) => {
  const token = getCookie("token");
  try {
    const url = categoryUrls[categoryName];
    if (!url) {
      throw new Error(`Invalid category name: "${categoryName}"`);
    }

    // Destructure everything from productData:
    const {
      name,
      description = "", // default to empty string if missing
      details = "",
      measurement,
    } = productData;

    const payload = {
      category: categoryName,
      name,
      picture_link: pictureLink,
      description,
      details,
      measurement,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/Admin/addProduct`,
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding products:", error);
    throw error;
  }
};

export const dynamicOfferFilter = async (filters = {}) => {
  try {
    const token = getCookie("token");
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/Admin/dynamicOfferFilter`,

      filters,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error("Error performing dynamic offer filter:", error);
    return { error: true, message: error.response?.data || error.message };
  }
};

export const offerActivation = async (offerId, status, category) => {
  try {
    const token = getCookie("token");

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/Admin/offerActivation`,
      {
        offerId,
        status,
        category,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error activating/deactivating offer:", error);
    return {
      error: true,
      message: error.response?.data?.error || error.message,
    };
  }
};

export const deleteProductDynamic = async (categoryName, productId) => {
  const token = getCookie("token");
  const url = `${process.env.REACT_APP_BASE_URL}/Admin/deleteProductDynamic`;
  if (!url) {
    throw new Error(`Invalid category name: "${categoryName}"`);
  }

  const payload = {
    category: categoryName,
    productId,
  };

  try {
    const response = await axios.post(url, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data; // { message: "…deleted successfully" }
  } catch (err) {
    console.error("Error deleting product:", err);
    throw err;
  }
};

export const calculateProductValues = async ({
  category,
  productId,
  productIds,
  date,
  startDate,
  endDate,
  monthlyTrend,
} = {}) => {
  const token = getCookie("token");
  const url = `${process.env.REACT_APP_BASE_URL}/Admin/calculateProductValues`;

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  const body = {};
  if (category) body.category = category;

  // ✅ Always send an array, whether single or multiple
  if (productIds && Array.isArray(productIds)) {
    body.products = productIds;
  } else if (productId) {
    body.products = [productId];
  }

  if (monthlyTrend) body.monthlyTrend = monthlyTrend;
  if (startDate && endDate) {
    body.startDate = startDate;
    body.endDate = endDate;
  } else if (date) {
    body.date = date;
  }

  try {
    const response = await axios.post(url, body, { headers });
    return response.data;
  } catch (error) {
    console.error(
      "Error calculating product values:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const editProductDynamic = async ({
  categoryName,
  productId,
  name,
  description,
  details,
  categoryid,
  prices,
  previous_price,
  pictureLink, // This will now be treated as a link
  measurements,
}) => {
  const token = getCookie("token");
  const base = categoryUrls[categoryName];
  if (!base) throw new Error(`Invalid category: "${categoryName}"`);
  const url = `${process.env.REACT_APP_BASE_URL}/Admin/editProductDynamic`;

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  // JSON payload
  const body = {
    category: categoryName,
    productId,
    ...(name !== undefined && { name }),
    ...(description !== undefined && { description }),
    ...(details !== undefined && { details }),
    ...(categoryid !== undefined && { categoryid }),
    ...(prices !== undefined && { prices }),
    ...(previous_price !== undefined && { previous_price }),
    ...(pictureLink !== undefined && { picture_link: pictureLink }),
    ...(measurements !== undefined && { measurement: measurements }),
  };
  try {
    const response = await axios.post(url, body, { headers });
    return response.data;
  } catch (err) {
    console.error("Error editing product:", err);
    throw err;
  }
};
export const editProductPropertiesValueDynamic = async ({
  propertyValueId,
  newValue,
  category,
}) => {
  const token = getCookie("token");
  const url = `${process.env.REACT_APP_BASE_URL}/Admin/editProductPropertiesValue`;

  let headers = { Authorization: `Bearer ${token}` };
  let body;

  // JSON payload
  body = {
    propertyValueId,
    newValue,
    category,
  };

  try {
    const response = await axios.post(url, body, { headers });
    return response.data;
  } catch (err) {
    console.error("Error editing product:", err);
    throw err;
  }
};

export const addProperties = async (name, categoryName) => {
  const token = getCookie("token");
  try {
    const url = categoryUrls[categoryName];
    if (!url) {
      throw new Error(`Invalid category name: "${categoryName}"`);
    }
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/Admin/addProductProperty`,
      { category: categoryName, name },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    // axios throws on non-2xx responses so this check may be optional
    return response.data;
  } catch (error) {
    console.error("Error adding properties: ", error);
    throw error;
  }
};

export const addPropertyValues = async (
  productId,
  productPropertyId,
  value,
  categoryName
) => {
  const token = getCookie("token");

  try {
    const url = categoryUrls[categoryName];
    if (!url) {
      throw new Error(`Invalid category name: "${categoryName}"`);
    }
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/Admin/addProductPropertyValue`,
      {
        category: categoryName,
        productId,
        productPropertyId,
        value,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    // axios throws on non-2xx responses so this check may be optional
    return response.data;
  } catch (error) {
    console.error("Error adding Property Values: ", error);
    throw error;
  }
};

export const getAllProductNames = async () => {
  try {
    const allProductNames = [];
    for (const categoryName in categoryUrls) {
      const baseUrl = categoryUrls[categoryName];
      const response = await axios.get(`${baseUrl}/fetchProduct`);
      const productNames = response.data.map((product) => product.name);
      allProductNames.push(...productNames);
    }

    return allProductNames; // Return only the names
  } catch (error) {
    console.error("Error fetching all Product Names: ", error);
    throw error;
  }
};

export const getProductById = async (productId, category) => {
  try {
    const baseUrl = categoryUrls[category];
    const response = await axios.post(`${baseUrl}/fetchProductById`, {
      productId,
    });
    return response.data;
  } catch (error) {
    console.error("Error finding the product: ", error);
    throw error;
  }
};

const categoryMapping = {
  CoffeeAndMainCommodities: "Coffee / ቡና",
  FruitCrops: "Fruit Crops / ፍራፍሬች",
  BuildingMaterials: "Building Materials / የግንባታ እቃዎች",
  GrainsAndCereals: "Grains and Cereals / የእህል ሰብሎች",
  PulsesLegumes: "Pulses & Legumes / ጥራጥሬዎች ",
  OilSeeds: "Oil Seeds / የቅባት እህሎች",
  RootCrops: "Root Crops / የስራስር ሰብሎች",
  Vegetables: "Vegetables  / አትክልቶች",
  SpicesHerbs: "Spice & Herbs / ቅመማ ቅመሞቾ",
};

export const createInteraction = async (
  category,
  poster_name,
  poster_phone_number,
  poster_business_type,
  poster_chat_id,
  viewer_name,
  viewer_phone_number,
  viewer_business_type,
  viewer_chat_id,
  offerId
) => {
  try {
    const mappedCategory = categoryMapping[category];
    if (!mappedCategory) {
      throw new Error(`Invalid category: ${category}`);
    }

    const Baseurl = categoryUrls[mappedCategory];
    const response = await axios.post(`${Baseurl}/createInteraction`, {
      poster_name,
      poster_phone_number,
      poster_business_type,
      poster_chat_id,
      viewer_name,
      viewer_phone_number,
      viewer_business_type,
      viewer_chat_id,
      offerId,
    });
    return response.data;
  } catch (error) {
    console.error("Error creating interaction:", error);
    throw error;
  }
};

export const fetchOffers = async (offerId, phoneNumber) => {
  try {
    for (const categoryName in categoryUrls) {
      const baseUrl = categoryUrls[categoryName];
      const response = await axios.get(`${baseUrl}/fetchOffers`, {
        params: { offerId, phoneNumber },
      });
      return response.data;
    }
  } catch (error) {
    console.error("Error fetching an offer : ", error);
  }
};

export const updateOffer = async (categoryName, offerData) => {
  try {
    const baseUrl = categoryUrls[categoryName];
    if (!baseUrl) {
      throw new Error(`No URL for category: ${categoryName}`);
    }

    const response = await axios.post(`${baseUrl}/updateOffer`, offerData);
    return response.data;
  } catch (error) {
    console.error("Error updating offer:", error);
    throw error;
  }
};

export const fetchProductDynamic = async (categoryName = null) => {
  const token = getCookie("token");
  const url = `${process.env.REACT_APP_BASE_URL}/Admin/fetchProductDynamic`;

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  let body = {};
  if (categoryName) {
    body.category = categoryName;
  }

  try {
    const response = await axios.post(url, body, { headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};

export const getAllProductsByCategory = async (categoryName) => {
  try {
    const baseUrl = categoryUrls[categoryName];
    if (!baseUrl) {
      throw new Error(`No URL for category: ${categoryName}`);
    }
    const response = await axios.get(`${baseUrl}/fetchProduct`);
    return response.data;
  } catch (error) {
    console.error("Error fetching all Products: ", error);
    throw error;
  }
};

export const getPropertiesByProduct = async (productId, categoryName) => {
  try {
    const baseUrl = categoryUrls[categoryName];
    if (!baseUrl) {
      throw new Error(`No URL mapped for category: ${categoryName}`);
    }

    const response = await axios.get(`${baseUrl}/fetchPropertyByProduct`, {
      params: { productId },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching properties by product: ", error);
    throw error;
  }
};

export const getAllProperties = async (cat) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/Admin/fetchAllProperties`,
      {
        category: cat,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching all properties: ", error);
    throw error;
  }
};

export const getPropertiesByCategory = async (categoryName) => {
  try {
    const baseUrl = categoryUrls[categoryName];
    if (!baseUrl) {
      throw new Error(`No URL mapped for category: ${categoryName}`);
    }
    const response = await axios.get(`${baseUrl}/fetchProperties`);
    return response.data;
  } catch (error) {
    console.error("Error fetching properties by product: ", error);
    throw error;
  }
};

export const getPropertyValues = async (
  productId,
  ProductPropertyId,
  categoryName
) => {
  try {
    const baseUrl = categoryUrls[categoryName];
    if (!baseUrl) {
      throw new Error(`No URL mapped for category: ${categoryName}`);
    }
    const response = await axios.get(`${baseUrl}/fetchPropertyValue`, {
      params: { productId, ProductPropertyId },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching property values: ", error);
    throw error;
  }
};

const resolveRepostBaseUrl = (categoryKey) => {
  // Try the repost-specific map first, then fall back to the main category map
  return categoryUrlsforRepost[categoryKey] || categoryUrls[categoryKey] || null;
};

export const updateRepostOffer = async (categoryKey, offerID) => {
  const baseUrl = resolveRepostBaseUrl(categoryKey);
  if (!baseUrl) {
    throw new Error(`No base URL defined for category: ${categoryKey}`);
  }

  try {
    const response = await axios.post(`${baseUrl}/offerRepostUpdate`, {
      id: offerID,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating repost offer: ", error);
    throw error;
  }
};

export const repostOffer = async (categoryKey, offerID) => {
  const baseUrl = resolveRepostBaseUrl(categoryKey);
  if (!baseUrl) {
    throw new Error(`No base URL defined for category: ${categoryKey}`);
  }
  try {
    const response = await axios.post(`${baseUrl}/repostOffer`, { id: offerID });
    return response.data;
  } catch (error) {
    console.error("Error reposting offer: ", error);
    throw error;
  }
};

const postOfferHelper = async (categoryKey, data) => {
  const baseUrl = categoryUrls[categoryKey];
  if (!baseUrl) {
    throw new Error(`No base URL defined for category: ${categoryKey}`);
  }
  return axios.post(`${baseUrl}/postOffer`, data);
};

export const mainCommoditiesOffer = async (data) => {
  try {
    const response = await postOfferHelper("Coffee / ቡና", data);
    return response.data;
  } catch (error) {
    console.error("Error saving Coffee offer: ", error);
    throw error;
  }
};

export const spiceOffer = async (data) => {
  try {
    const response = await postOfferHelper("Spice & Herbs / ቅመማ ቅመሞቾ", data);
    return response.data;
  } catch (error) {
    console.error("Error saving spices offer: ", error);
    throw error;
  }
};

export const buildingMaterialsOffer = async (data) => {
  try {
    const response = await postOfferHelper(
      "Building Materials / የግንባታ እቃዎች",
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error saving building materials offer: ", error);
    throw error;
  }
};

export const grainsOffer = async (data) => {
  try {
    const response = await postOfferHelper(
      "Grains and Cereals / የእህል ሰብሎች",
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error saving grains offer: ", error);
    throw error;
  }
};

export const PulsesOffer = async (data) => {
  try {
    const response = await postOfferHelper("Pulses & Legumes / ጥራጥሬዎች ", data);
    return response.data;
  } catch (error) {
    console.error("Error saving pulses offer: ", error);
    throw error;
  }
};

export const oilSeedsOffer = async (data) => {
  try {
    const response = await postOfferHelper("Oil Seeds / የቅባት እህሎች", data);
    return response.data;
  } catch (error) {
    console.error("Error saving oil seeds offer: ", error);
    throw error;
  }
};

export const rootCropsOffer = async (data) => {
  try {
    const response = await postOfferHelper("Root Crops / የስራስር ሰብሎች", data);
    return response.data;
  } catch (error) {
    console.error("Error saving root crops offer: ", error);
    throw error;
  }
};

export const VegetablesOffer = async (data) => {
  try {
    const response = await postOfferHelper("Vegetables  / አትክልቶች", data);
    return response.data;
  } catch (error) {
    console.error("Error saving vegetables offer: ", error);
    throw error;
  }
};

export const fruitCropsOffer = async (data) => {
  try {
    const response = await postOfferHelper("Fruit Crops / ፍራፍሬች", data);
    return response.data;
  } catch (error) {
    console.error("Error saving fruit offer: ", error);
    throw error;
  }
};

export const getCategories = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/Preference/categories`
    );
    return response.data.categories;
  } catch (error) {
    console.error("Error getting category :", error);
  }
};

export const getUserByPhoneNumber = async (contact_information, chat_id) => {
  try {
    let queryParams = new URLSearchParams();

    // Normalize number
    if (contact_information) {
      let normalizedNumber = contact_information;
      if (contact_information.startsWith("0")) {
        normalizedNumber = "+251" + contact_information.slice(1);
      }
      queryParams.append("contact_information", normalizedNumber);
    }

    if (chat_id) {
      queryParams.append("chat_id", chat_id);
    }

    const response = await axios.get(
      `${
        process.env.REACT_APP_BASE_URL
      }/UserService/fetchuser?${queryParams.toString()}`
    );

    return response.data;
  } catch (error) {
    console.error("Error getting user with phone:", error);
  }
};
